import {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
} from "./episode.service";

export const episodeService = {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
};
